/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PaidInputs */

const en_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const es_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagado`)
};

const fr_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payé`)
};

const de_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlt`)
};

const ja_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い済み`)
};

const zh_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已付款`)
};

const ar_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدفوع`)
};

const id_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dibayar`)
};

const it_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagato`)
};

const ru_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оплачено`)
};

const pt_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago`)
};

const ko_paid = /** @type {(inputs: PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`결제 완료`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {PaidInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const paid = /** @type {((inputs?: PaidInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PaidInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paid(inputs)
	if (locale === "es") return es_paid(inputs)
	if (locale === "fr") return fr_paid(inputs)
	if (locale === "de") return de_paid(inputs)
	if (locale === "ja") return ja_paid(inputs)
	if (locale === "zh") return zh_paid(inputs)
	if (locale === "ar") return ar_paid(inputs)
	if (locale === "id") return id_paid(inputs)
	if (locale === "it") return it_paid(inputs)
	if (locale === "ru") return ru_paid(inputs)
	if (locale === "pt") return pt_paid(inputs)
	return ko_paid(inputs)
});